export default "__VITE_ASSET__CPgEeSue__"